import { ChangeDetectionStrategy, Component, inject, signal } from '@angular/core';
import { ignore422 } from '../../utils/utils';
import { FileService, FileType } from '../../woo_services.module/FileService';
import { UserService } from '../../woo_services.module/UserService';

@Component({
  selector: 'signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: false,
})
export class Signup {
  FileType = FileType;
  readonly fileService = inject(FileService);
  readonly userService = inject(UserService);

  formSignup = {
    email: '',
    first_name: '',
    last_name: '',
    company: '',
    phone: '',
  };

  formSubmitSuccess = signal<boolean>(false);
  loading = signal<boolean>(false);

  submitSignupForm(): void {
    this.loading.set(true);
    this.userService.saveSignupUser(this.formSignup).then(() => {
      this.loading.set(false);
      this.formSubmitSuccess.set(true);
    }, ignore422);
  }
}
